import { h, Component } from 'preact';

export class ErrorBoundary extends Component {
    componentDidCatch(e) {
        if (!this.state.logged) {
            console.error(`Exception rendering component: ${this.props.name}`, e);                 
        }                
    }

    static getDerivedStateFromError(error) {
        return {
            error: true,
            logged: true
        }
    }

    render() {
        if (this.state.error) {
            return null;
        }

        return this.props.children;
    }
}